// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import BusinessCharacteristicsSchema from './business-characteristics-schema';

const schema = {
  $id: '/e-surance-membership-business-schema',
  type: 'object',
  required: ['accessionDate', 'name', 'street', 'zipCode', 'city'],
  properties: {
    accessionDate: {
      type: 'string',
      format: 'date-time',
    },
    name: {
      type: 'string',
      minLength: 1,
    },
    street: {
      type: 'string',
      minLength: 1,
    },
    houseNumber: {
      type: 'string',
      nullable: true,
    },
    zipCode: {
      type: 'string',
      minLength: 1,
    },
    zipCodeAddition: {
      type: 'string',
      nullable: true,
    },
    city: {
      type: 'string',
      minLength: 1,
    },
    hasApprenticeTraining: {
      type: 'boolean',
      nullable: true,
    },
    isSeasonalBusiness: {
      type: 'boolean',
      nullable: true,
    },
    businessCharacteristics: {
      ...BusinessCharacteristicsSchema,
    },
  },
} as IJSONSchema;

export default schema;
